import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../api";

const LABEL = {
  enviando: "Enviando…", processando_autorizacao: "Nota em processamento na prefeitura", autorizado: "Nota autorizada",
  erro_autorizacao: "Nota recusada", erro_envio: "Erro ao enviar", token_invalido: "Token do emissor inválido", cancelado: "Nota cancelada",
};

export const NfseActions = ({ s, fiscal, onChange, reload }) => {
  const [busy, setBusy] = useState(false);
  const nf = s.nfse || {};
  const run = async (fn, ok) => {
    setBusy(true);
    try { onChange((await fn()).data); if (ok) toast.success(ok); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); reload(); }
    finally { setBusy(false); }
  };
  const issue = () => window.confirm(`Emitir nota fiscal de ${s.clientName}?${fiscal?.environment === "producao" ? " (PRODUÇÃO — nota com valor fiscal)" : " (homologação — teste)"}`) && run(() => api.post(`/services/${s.id}/nfse`), "Nota enviada ao emissor.");
  const refresh = () => run(() => api.get(`/services/${s.id}/nfse`));
  const cancel = () => {
    const j = window.prompt("Motivo do cancelamento (mínimo 15 caracteres):");
    if (j) run(() => api.post(`/services/${s.id}/nfse/cancel`, { justificativa: j }), "Cancelamento solicitado.");
  };
  const canIssue = s.status !== "cancelado" && !["autorizado", "processando_autorizacao", "enviando"].includes(nf.status);

  return (
    <div className="nfse-line" data-testid={`nfse-${s.id}`}>
      {nf.status && <span className={`nfse-badge ${nf.status}`} data-testid={`nfse-status-${s.id}`}>{LABEL[nf.status] || nf.status}{nf.numero ? ` nº ${nf.numero}` : ""}{nf.env === "homologacao" ? " (teste)" : ""}</span>}
      {nf.error && nf.status !== "autorizado" && <small className="nfse-error">{nf.error}</small>}
      {canIssue && <button onClick={issue} disabled={busy || !fiscal?.hasToken} title={fiscal?.hasToken ? "" : "Ative a emissão na aba Nota fiscal"} data-testid={`nfse-issue-${s.id}`}>{busy ? "Enviando…" : "Emitir nota"}</button>}
      {!fiscal?.hasToken && canIssue && <small className="hint" style={{ margin: 0 }}>Emissão desativada</small>}
      {["processando_autorizacao", "enviando"].includes(nf.status) && <button onClick={refresh} disabled={busy} data-testid={`nfse-refresh-${s.id}`}>Atualizar situação</button>}
      {nf.status === "autorizado" && nf.url && <a href={nf.url} target="_blank" rel="noreferrer" data-testid={`nfse-pdf-${s.id}`}>Ver nota (PDF)</a>}
      {nf.status === "autorizado" && nf.xml && <a href={nf.xml} target="_blank" rel="noreferrer" data-testid={`nfse-xml-${s.id}`}>XML</a>}
      {nf.status === "autorizado" && <button onClick={cancel} disabled={busy} data-testid={`nfse-cancel-${s.id}`}>Cancelar nota</button>}
    </div>
  );
};
